import {
  ACTIVE_REVIEW_STATUSES,
  DETECTED_ISSUE_CITATION_URL,
  DETECTED_ISSUE_EXPLANATION_MARKDOWN_URL,
  DETECTED_ISSUE_REVIEW_STATUS_SYSTEM,
} from './detectedIssueConstants';

const getDisplayFromCodeableConcept = (concept: unknown): string => {
  if (!concept || typeof concept !== 'object') return '—';
  const typed = concept as {
    coding?: Array<{ display?: string; code?: string }>;
    text?: string;
  };
  return (
    typed.coding?.find(c => c.display)?.display ||
    typed.coding?.[0]?.code ||
    typed.text ||
    '—'
  );
};

export const getDetectedIssueCategoryDisplay = (
  resource: fhir.DetectedIssue,
): string => getDisplayFromCodeableConcept(resource.category);

export const getDetectedIssueReviewStatus = (
  resource: fhir.DetectedIssue,
): string | undefined => {
  for (const mitigation of resource.mitigation || []) {
    const action = mitigation?.action;
    if (!action?.coding) continue;
    for (const coding of action.coding) {
      if (coding.system === DETECTED_ISSUE_REVIEW_STATUS_SYSTEM) {
        return coding.code;
      }
    }
  }
  return undefined;
};

export const getDetectedIssueExplanationMarkdown = (
  resource: fhir.DetectedIssue,
): string | undefined => {
  const extension = (resource.extension || []).find(
    ext => ext.url === DETECTED_ISSUE_EXPLANATION_MARKDOWN_URL,
  );
  return extension?.valueString;
};

export const getDetectedIssueCitations = (
  resource: fhir.DetectedIssue,
): Array<{ reference: string; display: string }> => {
  return (resource.extension || [])
    .filter(ext => ext.url === DETECTED_ISSUE_CITATION_URL)
    .map(ext => ({
      reference: ext.valueReference?.reference || '—',
      display:
        ext.valueReference?.display || ext.valueReference?.reference || '—',
    }));
};

export const isActiveDetectedIssue = (
  resource: fhir.DetectedIssue,
): boolean => {
  const reviewStatus = getDetectedIssueReviewStatus(resource);
  return reviewStatus ? ACTIVE_REVIEW_STATUSES.has(reviewStatus) : false;
};

export const isPendingDetectedIssue = (
  resource: fhir.DetectedIssue,
): boolean => {
  const reviewStatus = getDetectedIssueReviewStatus(resource);
  return reviewStatus === 'needs-review' || resource.status === 'preliminary';
};

export const formatDetectedIssueCategoryCode = (code: string): string =>
  code.replace(/-/g, ' ');
